const CorporateLogo = (props) => {
    return <img {...props} src={'/images/mitsubishi-eu-logo.svg'} alt={'Logo Mitsubishi Electric'} />;
};
export default CorporateLogo;
